function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M502.1,203L345.7,39.4c-22-22.9-61.3-7.7-61.3,24.6v78.4C137.4,144.1,0,170.8,0,322.8C0,407.3,49.6,456.4,79.2,478 c21.5,15.8,51.6-4.4,44.2-30.7C89.7,327.9,147.2,314.6,284.4,313v78.1c0,32.2,39.3,47.6,61.3,24.6l156.4-163.6 C515.3,238.4,515.3,216.7,502.1,203L502.1,203z M481.6,232.5L325.1,396c-4.4,4.6-12.2,1.5-12.2-4.9V284.4 c-152.4,0-262.5,8.6-216.9,170.4c-32-23.4-67.6-65.9-67.6-132c0-142.2,144.8-152.2,284.4-152.2V64c0-6.5,7.9-9.5,12.2-4.9 l156.4,163.6C484.2,225.4,484.2,229.7,481.6,232.5L481.6,232.5z"
});

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.7efec16f.svg";
export { ForwardRef as ReactComponent };